module.exports = __webpack_public_path__ + "static/media/960w.abd46855.jpg";